module.exports = __webpack_public_path__ + "static/media/square.05ca6461.svg";